import {EnvironmentalVars} from './environment.model';

const appSettings = window[EnvironmentalVars.APPSETTINGS];

const keycloakConfig: any = {
    url: appSettings ? appSettings[EnvironmentalVars.KEYCLOAK_URL] : "",
    realm: appSettings ? appSettings[EnvironmentalVars.KEYCLOAK_REALM] : "",
    clientId: appSettings ? appSettings[EnvironmentalVars.KEYCLOAK_CLIENT] : "",
};
const appVersion = require('../../package.json').version;
export const environment = {
    production: true,
    target: appSettings ? appSettings[EnvironmentalVars.TARGET] : "",
    buildEnv: appSettings ? appSettings[EnvironmentalVars.BUILD_ENV] : "",
    use_current_url: true,
    version: appVersion,
    base_url: appSettings ? appSettings[EnvironmentalVars.BASE_URL] : "",
    keycloak: keycloakConfig,
    roleCheck: 'fs-portal',
    localhostDev: false,
    supportServicePrefix: appSettings ? appSettings[EnvironmentalVars.SUPPORT_SERVICE_PREFIX] : "",
};
